import _ from 'lodash';

import languages from './languages';

/**
 * TODO: Languages should become enums under constants/languages and change this implementation then
 */

interface KeyValue {
  [key: string]: string;
}

export const MOMENT_LOCALES: KeyValue = {
  ..._.zipObject(languages, languages),
  tl: 'tl-ph',
  zh: 'zh-cn',
  no: 'nb',
};

const DEFAULT_DATE_FORMAT = 'MMM D';

export const DATE_FORMATS: KeyValue = {
  ..._.reduce(languages, (acc, value) => ({ ...acc, [value]: DEFAULT_DATE_FORMAT }), {}),
  ko: 'MMM D일',
};
